import Tabs, { Tab } from '~/components/Tabs';

import styles from './Embed.style';

let scriptSrc = 'https://clearbitjs.com/v1/x/forms.js';

class Embed extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      codeTab: 0,
    };
  }

  getFallback() {
    const { form } = this.props;
    if (!form.fallback_url) return;

    return `Please complete <a href="${form.fallback_url}" target="_blank">our lead form</a>.`;
  }

  getEmbedCode() {
    const { form } = this.props;

    let value = '';
    value += `<script type="text/javascript" src="${scriptSrc}"></script>\n`;
    value += `<div class="clearbit-form" `;
    value += `data-form-id="${form.id}" `;
    value += `data-theme="${form.theme || 'default'}" `;
    value += `>${this.getFallback() || ''}</div>`;

    return value;
  }

  getOverlayCode() {
    const { form } = this.props;

    let value = '';
    value += `<script type="text/javascript" src="${scriptSrc}"></script>\n`;
    value += `<a class="clearbit-overlay" `;
    value += `data-form-id="${form.id}" `;
    value += `data-theme="${form.theme || 'default'}" `;
    value += `>Contact sales</a>`;

    return value;
  }

  selectEmbed() {
    this.refs.embed.select();
  }

  selectOverlay() {
    this.refs.overlay.select();
  }

  render() {
    const { classes } = this.props;
    const { codeTab } = this.state;

    return (
      <div>
        <Tabs
          className={classes.tabs}
          value={codeTab}
          onChange={(index) => this.setState({ codeTab: index })}>
          <Tab label="Embed code" />
          <Tab label="Overlay code" />
        </Tabs>

        {codeTab === 0 && (
          <div className={classes.embed}>
            <textarea
              ref="embed"
              value={this.getEmbedCode()}
              className={classes.embedTextarea}
              onClick={this.selectEmbed.bind(this)}
              readOnly
            />
          </div>
        )}

        {codeTab === 1 && (
          <div className={classes.embed}>
            <textarea
              ref="overlay"
              value={this.getOverlayCode()}
              className={classes.embedTextarea}
              onClick={this.selectOverlay.bind(this)}
              readOnly
            />
          </div>
        )}
      </div>
    );
  }
}

Embed.propTypes = {
  form: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Embed);
